// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-row {
  height: 60px;
  text-align: center;
  border-style: solid;
  border-width: 0 0 2px 0;
  border-color: #f6f6f6;
}
ion-row.selected {
  background-color: #e6d6eb;
}
ion-row.unselected {
  background-color: #ebebeb;
}

ion-button {
  height: 100%;
}

ion-radio {
  padding: 0;
  border-radius: 12px;
  border: 1px solid #d8d8d8;
  background-color: white;
  height: 24px;
  width: 24px;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

ion-checkbox {
  --border-radius: 0;
  height: 24px;
  width: 24px;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.arrow {
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 24px;
  height: 24px;
}

.hierarchyContainer {
  display: flex;
  align-items: center;
  text-align: left;
  height: 100%;
}

.hierarchyLabel {
  color: #6b6d6f;
  font-family: Gotham-Medium;
  font-size: 14px;
  font-weight: 500;
}

.hierarchyLabelMuted {
  color: rgb(138, 138, 138);
  font-family: Gotham-Medium;
  font-size: 10px;
  font-weight: 500;
}

.checkContainer {
  border-style: solid;
  border-width: 0 0 0 1px;
  border-color: #f6f6f6;
}

.hierarchyRow {
  width: 100%;
  display: inline-flex;
  min-height: 4em;
  text-align: center;
  border-style: solid;
  border-width: 0 0 2px 0;
  border-color: #f6f6f6;
}
.hierarchyRow.selected {
  background-color: #e6d6eb;
}
.hierarchyRow.unselected {
  background-color: #ebebeb;
}

.hierarchyCol-icon {
  width: 10%;
  display: inline-flex;
  max-width: 80px;
}

.hierarchyCol-content {
  width: -webkit-fill-available;
  display: inline-flex;
}

.hierarchyCol-check {
  width: 10%;
  max-width: 120px;
  min-width: 100px;
  display: inline-flex;
  margin-left: auto;
  margin-right: 0px;
}`, "",{"version":3,"sources":["webpack://./src/components/hierarchy-cell/hierarchy-cell.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AACF;AACE;EACE,yBAAA;AACJ;AAEE;EACE,yBAAA;AAAJ;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AADF;;AAIA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AADF;;AAIA;EACE,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AADF;;AAIA;EACE,cAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,yBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,mBAAA;EACA,uBAAA;EACA,qBAAA;AADF;;AAIA;EACE,WAAA;EACA,oBAAA;EAEA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AAFF;AAIE;EACE,yBAAA;AAFJ;AAKE;EACE,yBAAA;AAHJ;;AAOA;EACE,UAAA;EACA,oBAAA;EACA,eAAA;AAJF;;AAOA;EACE,6BAAA;EACA,oBAAA;AAJF;;AAOA;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,iBAAA;AAJF","sourcesContent":["ion-row {\n  height: 60px;\n  text-align: center;\n  border-style: solid;\n  border-width: 0 0 2px 0;\n  border-color: #f6f6f6;\n\n  &.selected {\n    background-color: #e6d6eb;\n  }\n\n  &.unselected {\n    background-color: #ebebeb;\n  }\n}\n\nion-button {\n  height: 100%;\n}\n\nion-radio {\n  padding: 0;\n  border-radius: 12px;\n  border: 1px solid #d8d8d8;\n  background-color: white;\n  height: 24px;\n  width: 24px;\n  margin: auto;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\nion-checkbox {\n  --border-radius: 0;\n  height: 24px;\n  width: 24px;\n  margin: auto;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.arrow {\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 24px;\n  height: 24px;\n}\n\n.hierarchyContainer {\n  display: flex;\n  align-items: center;\n  text-align: left;\n  height: 100%;\n}\n\n.hierarchyLabel {\n  color: #6b6d6f;\n  font-family: Gotham-Medium;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.hierarchyLabelMuted {\n  color: rgb(138, 138, 138);\n  font-family: Gotham-Medium;\n  font-size: 10px;\n  font-weight: 500;\n}\n\n.checkContainer {\n  border-style: solid;\n  border-width: 0 0 0 1px;\n  border-color: #f6f6f6;\n}\n\n.hierarchyRow {\n  width: 100%;\n  display: inline-flex;\n\n  min-height: 4em;\n  text-align: center;\n  border-style: solid;\n  border-width: 0 0 2px 0;\n  border-color: #f6f6f6;\n\n  &.selected {\n    background-color: #e6d6eb;\n  }\n\n  &.unselected {\n    background-color: #ebebeb;\n  }\n}\n\n.hierarchyCol-icon {\n  width: 10%;\n  display: inline-flex;\n  max-width: 80px;\n}\n\n.hierarchyCol-content {\n  width: -webkit-fill-available;\n  display: inline-flex;\n}\n\n.hierarchyCol-check {\n  width: 10%;\n  max-width: 120px;\n  min-width: 100px;\n  display: inline-flex;\n  margin-left: auto;\n  margin-right: 0px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
